import React from 'react';
import styled from 'styled-components';

interface DotWithLabelProps {
  initialColor: string;
  label: string;
}

const DotWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Dot = styled.div<{ color: string }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  display: inline-block;
  margin-right: 8px;
`;

const Label = styled.span`
  font-size: 16px;
`;

const DotWithLabel: React.FC<DotWithLabelProps> = ({ initialColor, label }) => {

  return (
    <DotWrapper>
      <Dot color={initialColor} />
      <Label>{label}</Label>
    </DotWrapper>
  );
};

export default DotWithLabel;
